// extracted by mini-css-extract-plugin
export default {"container":"Outline_container__oH6oM","uppercase":"Outline_uppercase__fW1XW","label":"Outline_label__ncDBU","edit":"Outline_edit__toat-","ready_issues":"Outline_ready_issues__phQIk"};